import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom } from 'rxjs/operators';

import * as fromStore from '../store';
import { of } from 'rxjs';
import { EventFilters } from '../models';
import { SetMenuTheme } from 'src/app/store';

export const EventOverviewGuard: CanActivateFn = route => {
  const store = inject(Store);
  return store
    .select(fromStore.getEventsOverviewLoaded)
    .pipe(
      withLatestFrom(store.select(fromStore.getEventsPage), store.select(fromStore.getEventsOverviewLoading)),
      tap(([loaded, page, loading]) => {
        const currentPage = +route.queryParams['page'] || 0;
        //const filter = +route.data['filter'] || 1;

        store.dispatch(SetMenuTheme('secondary'));

        let filters: EventFilters = {
          from: route.queryParams['from'] || null,
          to: route.queryParams['to'] || null,
          eventType: asArray(route.queryParams['eventType']),
          categories: asArray(route.queryParams['categories']),
          ageRequirements: asArray(route.queryParams['ageRequirements']),
          accessibilityFeatures: asArray(route.queryParams['accessibilityFeatures']),
          discounts: asArray(route.queryParams['discounts']),
          themes: asArray(route.queryParams['themes']),
          locations: asArray(route.queryParams['locations']),
          departments: asArray(route.queryParams['departments']),
          date: route.queryParams['date'] || null,
        };

        if ((!loaded || currentPage !== page.currentPage || JSON.stringify(page.filters) !== JSON.stringify(filters)) && !loading) {
          store.dispatch(
            fromStore.LoadEventsOverview({
              skip: currentPage * page.pageSize,
              take: page.pageSize,
              filters,
            })
          );
        }
      }),
      filter(([loaded]) => !!loaded),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};

const asArray = (value: any) => {
  if (!value) {
    return undefined;
  }
  if (Array.isArray(value)) {
    return value.map(v => +v);
  }
  return [+value];
};
